(function () {
    'use strict';

    angular
        .module('garnaCabinet')
        .controller('ProfileController', ProfileController);

    ProfileController.$inject = ['User', 'UserService', '$mdDialog', '_', 'moment'];

    /* @ngInject */
    function ProfileController(User, UserService, $mdDialog, _, moment) {
        var vm = this;
        vm.model = {
            loading: false,
            updateAvatar: false,
            user: {},
            minDate: moment('1900-01-01', 'YYYY-MM-DD').toDate(),
            maxDate: moment().subtract(18, 'years').toDate()
        };

        vm.canUpdate = canUpdate;

        vm.changeAvatar = changeAvatar;
        vm.changeSex = changeSex;
        vm.reverse = reverse;
        vm.update = update;

        var user;

        activate();

        ////////////////

        function activate() {
            user = UserService.getUser();

            user.birthdate = moment(user.birthday, 'YYYY-MM-DD', true).isValid() ? moment(user.birthday, 'YYYY-MM-DD', true).toDate() : null;
            user.avatar = UserService.getAvatar(user);
            vm.model.user = _.clone(user);


        }

        function canUpdate() {
            return !_.isEqual(vm.model.user, user);
        }

        function changeAvatar() {
            var dialog = $mdDialog.show({
                templateUrl: 'templates/profile/changeAvatar.html',
                controller: 'ChangeAvatarController',
                controllerAs: 'vm',
                locals: {
                    user: vm.model.user
                }
            });
            dialog.then(function (avatar) {
                vm.model.user.avatar = avatar;
                vm.model.updateAvatar = true;
            }, function () {
            })
        }

        function changeSex(sex) {
            if(readonly()) {
                return;
            }
            vm.model.user.sex = sex == 'man' ? 'm' : 'f';
        }

        function reverse() {
            vm.model.user = _.clone(user);
            vm.model.updateAvatar = false;
        }

        function update() {
            if (moment(vm.model.user.birthdate).isValid()) {
                vm.model.user.birthday = moment(vm.model.user.birthdate).format('YYYY-MM-DD');
            }
            var user_ = _.clone(vm.model.user);

            if (!vm.model.updateAvatar) {
                delete user_.avatar;
            }
            delete user_.birthdate;

            _startLoading();

            User.update(user_)
                .$promise
                .then(function () {
                    user = _.clone(vm.model.user);
                    _showAlert('Данные обновлены', null, _stopLoading);
                }, _stopLoading);
        }


        function _startLoading() {
            if (vm.model.loading) {
                _showAlert('Подождите!', 'Данные обрабатываются!');
                return;
            }
            vm.model.loading = true;
        }

        function _stopLoading() {
            vm.model.loading = false;
        }

        function _showAlert(title, msg, action) {
            var alert = $mdDialog.alert({
                title: title,
                textContent: msg,
                ok: 'ОК'
            });
            $mdDialog
                .show(alert)
                .finally(action);
        }
    }

})();

